import { Logo } from '@stratascratch/ui'
import { Link } from 'gatsby'
import FollowButtons from './FollowBtns'

import {
  root,
  column,
  title,
  paragraph,
  menuItem,
  copyright,
} from './FooterMain.module.css'

import { PLATFORM_BASE_URL } from '../constants'

function FooterMain() {
  return (
    <footer>
      <div className={root}>
        <div>
          <Link to="/" style={{ paddingTop: 30, display: 'block' }}>
            <Logo />
          </Link>
          <p className={paragraph}>
            Data science interview questions from your favorite companies.
            Prepare for a career with SQL, python, algorithms, statistics,
            probability, product sense, system design, and other real interview
            questions.
          </p>
          <FollowButtons />
        </div>
        <div className={column}>
          <h5 className={title}>Solutions</h5>
          <a href={`${PLATFORM_BASE_URL}/coding`} className={menuItem}>
            Coding Questions
          </a>
          <a href={`${PLATFORM_BASE_URL}/technical`} className={menuItem}>
            Non-Coding Questions
          </a>
          <a href={`${PLATFORM_BASE_URL}/login`} className={menuItem}>
            Login
          </a>
          <a href={`${PLATFORM_BASE_URL}/registration`} className={menuItem}>
            Register
          </a>
        </div>
        <div className={column}>
          <h5 className={title}>Company</h5>
          <a href={`${PLATFORM_BASE_URL}/pricing`} className={menuItem}>
            Pricing
          </a>
          <Link to="/blog/" className={menuItem}>
            Blog
          </Link>
          <Link to="/about/" className={menuItem}>
            About Us
          </Link>
          <Link to="/contact-us/" className={menuItem}>
            Contact Us
          </Link>
        </div>
        <div className={column} style={{ alignContent: 'start' }}>
          <h5 className={title}>Support</h5>
          <Link to="/terms-and-conditions/" className={menuItem}>
            Terms and Conditions
          </Link>
          <Link to="/privacy-policy/" className={menuItem}>
            Privacy Policy
          </Link>
        </div>
      </div>
      <div className={copyright}>
        &copy; {new Date().getFullYear()} StrataScratch, LLC. All rights
        reserved.
      </div>
    </footer>
  )
}

export default FooterMain
